import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import AlbumForm from '@/components/feature/AlbumForm';
import { getAlbumById, updateAlbum, type AlbumData } from '@/services/albumService';

export default function AlbumEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [album, setAlbum] = useState<AlbumData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      navigate('/albums');
      return;
    }
    const load = async () => {
      try {
        const found = await getAlbumById(id);
        if (!found) {
          navigate('/albums');
          return;
        }
        setAlbum(found);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id, navigate]);

  const handleSubmit = async (data: { title: string; description: string; coverImage: string }) => {
    if (!id) return;
    await updateAlbum(id, data);
    navigate(`/album/${id}`);
  };

  const handleCancel = () => {
    navigate(`/album/${id}`);
  };

  if (loading || !album) {
    return (
      <div className="flex flex-col min-h-screen">
        <header className="sticky top-0 z-20 bg-background-50/95 backdrop-blur-sm border-b border-background-200/50">
          <div className="flex items-center gap-3 px-4 py-3">
            <button
              onClick={handleCancel}
              className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-secondary-100 transition-colors cursor-pointer flex-shrink-0"
              aria-label="뒤로 가기"
            >
              <i className="ri-arrow-left-line text-xl text-foreground-700"></i>
            </button>
            <h1 className="text-base font-bold text-foreground-950">앨범 수정</h1>
          </div>
        </header>
        <div className="flex items-center justify-center py-20">
          <div className="w-8 h-8 border-2 border-accent-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <header className="sticky top-0 z-20 bg-background-50/95 backdrop-blur-sm border-b border-background-200/50">
        <div className="flex items-center gap-3 px-4 py-3">
          <button
            onClick={handleCancel}
            className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-secondary-100 transition-colors cursor-pointer flex-shrink-0"
            aria-label="뒤로 가기"
          >
            <i className="ri-arrow-left-line text-xl text-foreground-700"></i>
          </button>
          <h1 className="text-base font-bold text-foreground-950">앨범 수정</h1>
        </div>
      </header>

      {/* Form */}
      <section className="px-4 py-6">
        <AlbumForm
          initialTitle={album.title}
          initialDescription={album.description}
          initialCoverImage={album.coverImage}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitLabel="저장하기"
        />
      </section>
    </div>
  );
}